import React from "react";
import Table from "./Table";
import { HReflexRowType } from "../types/NCS_EMG";

interface HReflexTableProps {
  rows: HReflexRowType[];
  setRows: React.Dispatch<React.SetStateAction<HReflexRowType[]>>;
}

const headers = ["Nerve", "Side", "Stim", "Rec", "Lat(ms)", "Note"];

const HReflexTable: React.FC<HReflexTableProps> = ({ rows, setRows }) => {
  const addDefaultRows = () => {
    const newRows: HReflexRowType[] = ["Rt.", "Lt."].map((side) => ({
      Nerve: "Tibial",
      Side: side,
      Stim: "Popliteal",
      Rec: "Soleus",
      "Lat(ms)": "",
      Note: "",
    }));

    setRows((prev) => {
      const updated = [...prev];
      let filled = 0;

      for (let index = 0; index < updated.length && filled < newRows.length; index++) {
        const isEmpty = Object.values(updated[index]).every(
          (value) => !value || value.trim() === ""
        );

        if (isEmpty) {
          updated[index] = { ...updated[index], ...newRows[filled++] };
        }
      }

      return filled < newRows.length
        ? [...updated, ...newRows.slice(filled)]
        : updated;
    });
  };

  return (
    <section className="section-block">
      <div className="section-header">
        <h2 className="section-title">H-reflex</h2>

        <div className="toolbar">
          <button onClick={addDefaultRows} className="app-button secondary small">
            + Add Tibial Preset
          </button>
        </div>
      </div>

      <Table<HReflexRowType>
        title=""
        headers={headers}
        rows={rows}
        setRows={setRows}
        nerveOptions={["Tibial"]}
        sideOptions={["Rt.", "Lt."]}
        stimOptions={["Popliteal"]}
        recOptions={["Soleus"]}
        muscleOptions={[]}
        dropdownOptions={{ Note: ["Absent", "Prolonged"] }}
        hideAddRow={true}
      />
    </section>
  );
};

export default HReflexTable;
